import { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, MapPin } from "lucide-react";
import { api, jobPhotoSrc } from "../../lib/api";
import { CompareSlider } from "../CompareSlider";

export function FeaturedTransformation() {
  const [jobs, setJobs] = useState([]);

  useEffect(() => {
    api.get("/jobs").then((r) => setJobs(r.data || [])).catch(() => {});
  }, []);

  const featured = useMemo(() => {
    const groups = new Map();
    for (const j of jobs) {
      const k = `${(j.job_site_name || "").toLowerCase()}|${(j.location || "").toLowerCase()}`;
      if (!groups.has(k)) groups.set(k, []);
      groups.get(k).push(j);
    }
    let best = null;
    for (const group of groups.values()) {
      const before = group.find((p) => p.phase === "before");
      const after = group.find((p) => p.phase === "after");
      if (before && after && (!best || (after.date || "") > (best.after.date || ""))) {
        best = { before, after };
      }
    }
    return best;
  }, [jobs]);

  if (!featured) return null;
  const j = featured.after;

  return (
    <section className="bg-[#23282B]" data-testid="featured-transformation">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10 lg:px-16 py-24 md:py-32">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-center">
          <div className="lg:col-span-5">
            <div className="text-[#9CC4DB] text-xs tracking-[0.35em] font-bold uppercase mb-3">The Proof Is in the Dirt</div>
            <h2 className="font-display text-5xl sm:text-6xl md:text-7xl uppercase leading-[0.95] text-white">From rough ground<br />to finished work.</h2>
            <p className="mt-6 text-white/75 text-base md:text-lg max-w-md">
              Drag the slider to see a real job transform — shot on site by our own crew, start to finish.
            </p>
            <div className="mt-4 text-sm text-white/60 flex flex-wrap gap-x-4 gap-y-1">
              <span className="text-[#9CC4DB] font-semibold uppercase tracking-wider">{j.service_type}</span>
              {j.location && <span className="inline-flex items-center gap-1"><MapPin size={13} /> {j.location}</span>}
            </div>
            <Link to="/past-jobs" data-testid="featured-see-all" className="mt-8 inline-flex items-center gap-3 bg-[#2F5F80] hover:bg-[#234B66] text-white text-sm font-bold tracking-[0.15em] px-7 py-4 uppercase transition-colors">
              See All Transformations <ArrowRight size={16} />
            </Link>
          </div>
          <div className="lg:col-span-7">
            <div className="border-2 border-white/10 shadow-[0_30px_80px_rgba(0,0,0,0.5)]">
              <CompareSlider beforeSrc={jobPhotoSrc(featured.before)} afterSrc={jobPhotoSrc(featured.after)} alt={j.job_site_name} idx="home" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
